/* eslint-disable @typescript-eslint/naming-convention */
import { useRouter } from "next/router";
import { useAnalytics } from "~/components/Analytics";
import { HeroWithDemo as HeroWithDemoBlock } from "~/components/LandingPage/schemas";
import { useToastManager } from "~/components/ToastManager";
import { HeroWithDemo } from "~/landing-pages/components/Hero/HeroWithDemo/HeroWithDemo";
import { requestDemo } from "~/lib/client/endilApiCalls";
import { RequestDemoFormSchema } from "~/lib/shared/schemas/requestDemoSchema";

export type HeroWithDemoImplementationProps = HeroWithDemoBlock;
/**
 * Wrapper around HeroWithDemo with implementation to be used directly
 *
 * Additionally, handles the transformation of the large image object into imageUrl and imageAlt
 * */
export const HeroWithDemoImplementation: React.FC<
  HeroWithDemoImplementationProps
> = ({
  eventName,
  image,
  salesforceCampaignId,
  successMessage,
  successRedirectUrl,
  ...rest
}) => {
  const { analyticsEnhancedTrack } = useAnalytics();
  const { addToast } = useToastManager();
  const { asPath, push, query } = useRouter();

  const {
    campaignId,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  } = query;

  const onFormSubmit = async (values: RequestDemoFormSchema) => {
    analyticsEnhancedTrack(eventName);

    await requestDemo({
      ...values,
      eventName,
      pageUrl: asPath.split("?")[0],
      iterableCampaignId: campaignId,
      utmSource: utm_source,
      utmMedium: utm_medium,
      utmCampaign: utm_campaign,
      utmTerm: utm_term,
      utmContent: utm_content,
    });

    addToast("success", successMessage);

    push(successRedirectUrl.url);
  };

  return (
    <HeroWithDemo
      {...rest}
      onFormSubmit={onFormSubmit}
      imageAlt={image.alt}
      imageUrl={image.url}
      salesforceCampaignId={salesforceCampaignId}
    />
  );
};
